export function cleanObject(obj) {
    const cleaned = { ...obj };
    for (let key in cleaned) {
        if (cleaned[key] === null || cleaned[key] === "" || cleaned[key] === 0) {
            delete cleaned[key];
        }
    }
    return cleaned;
}